import actionCreatorFactory from 'typescript-fsa';
import { SqlStatistics } from '../../../services/betting';
import { ServerType } from '../../System/systemConfig';

const actionCreator = actionCreatorFactory();

export const SQL_STATS_LOAD = 'SQL_STATS_LOAD';
export const loadSqlStatisticsAction = actionCreator<ServerType>(SQL_STATS_LOAD);

export const SQL_STATS_SET_STATS = 'SQL_STATS_SET_STATS';
export const setSqlStatisticsAction = actionCreator<{ serverName: ServerType; stats: SqlStatistics[] }>(
    SQL_STATS_SET_STATS
);

export const SQL_STATS_SET_AVAILABLE = 'SQL_STATS_SET_AVAILABLE';
export const setSqlStatisticsServerAvailable = actionCreator<{ serverName: ServerType; available: boolean }>(
    SQL_STATS_SET_AVAILABLE
);

export const SQL_STATS_CLEAR = 'SQL_STATS_CLEAR';
export const sqlStatsClear = actionCreator<ServerType>(SQL_STATS_CLEAR);
